import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Loading from '../../Components/UiLoadingComponents/Loading';
import { useGetAllAssignmentMarkQuery } from '../../features/assignmentMark/assignmentMarkApi';
import { setFilter } from '../../features/filter/filter';
import { selectFilter } from '../../features/filter/fitlerSelector';
import AssignmentMarkSingleTableRow from './AssignmentMarkSingleTableRow';

const AssignmentMark = () => {
    const { data, isLoading, isError, isSuccess } = useGetAllAssignmentMarkQuery()
    const { all, pending, markSent } = useSelector(selectFilter)
    const dispatch = useDispatch()


    const handleFilter = (filterInfo) => {
        dispatch(setFilter(filterInfo))

    }
    let content = null
    if (isLoading) {
        content = <div>
            <Loading className='center-of-window'></Loading>
        </div>
    } else if (isSuccess && !data.length) {
        content = <div className='text-center text-xl text-error'>
            Data not found
        </div>

    } else {
        const dataLength = data.length;
        const pendingDataLength = data.filter(single => single.status === 'pending').length;
        const markSentDataLength = dataLength - pendingDataLength;

        const filterData = data.filter(single => {
            if (all) {
                return true
            }
            else if (markSent) {
                return single.status === 'published'
            } else {
                return single.status === 'pending'
            }
        })
        content = <div className="mx-auto max-w-full px-5 lg:px-20">
            <div className="px-3 py-20 bg-opacity-10">
                <div className='flex justify-between items-center'>
                    <div>
                        <h4 className='text-lg font-semibold'>Filter by</h4>
                        <div className="assignment-filter mt-2">
                            <button className={`filter-btn ${all && 'active'}`} onClick={() => handleFilter({
                                all: true,
                            })}>All</button>
                            <button
                                className={`filter-btn ${pending && 'active'}`}
                                onClick={() => handleFilter({
                                    pending: true,
                                })}>Pending</button>
                            <button
                                className={`filter-btn ${markSent && 'active'}`}
                                onClick={() => handleFilter({
                                    markSent: true
                                })}>Mark Sent</button>
                        </div>

                    </div>
                    <ul className="assignment-status">
                        <li>Total <span>{dataLength}</span></li>
                        <li>Pending <span>{pendingDataLength}</span></li>
                        <li>Mark Sent <span>{markSentDataLength}</span></li>
                    </ul>
                </div>
                <div className="overflow-x-auto mt-4">
                    {
                        filterData.length ? <table className="divide-y-1 text-base divide-gray-600 w-full">
                            <thead>
                                <tr>
                                    <th className="table-th">Assignment</th>
                                    <th className="table-th">Date</th>
                                    <th className="table-th">Student Name</th>
                                    <th className="table-th">Repo Link</th>
                                    <th className="table-th">Mark</th>
                                </tr>
                            </thead>

                            <tbody className="divide-y divide-slate-600/50">
                                {
                                    filterData.map(single => <AssignmentMarkSingleTableRow key={single.id} data={single}></AssignmentMarkSingleTableRow>)
                                }
                            </tbody>
                        </table> :
                            <div className='text-center text-xl text-error'>
                                Data not found!
                            </div>
                    }
                </div>
            </div>
        </div>
    }
    return (
        <section className="py-6 bg-primary">
            {content}
        </section>
    );
};

export default AssignmentMark;